import { useQuery } from "@tanstack/react-query";
import { baseUrl, token } from "api";
import { API_ENDPOINTS } from "../apiEndPoints";
import axios from "axios";

const fetchCategory = async () => {
  // Try the alternative endpoint first
  try {
    const response = await axios.get(`${baseUrl}${API_ENDPOINTS.Categories}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    // Fallback to original endpoint
    const response = await axios.get(`${baseUrl}${API_ENDPOINTS.Category}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
};

const useCategoryData = () => {
  const { data: CategoryData, isLoading } = useQuery({
    queryKey: ["Category"], // Adjust queryKey as per your API requirements
    queryFn: fetchCategory,
    staleTime: 1000 * 60 * 5, // Adjust staleTime as needed
  });

  return { CategoryData, isLoading };
};

export default useCategoryData;
